import React from 'react';
import { AMBERWOOD_POSTER } from './AmberwoodSplash';
import './AmberwoodResearchBanner.css';

/** Launch prices as printed on the campaign poster. */
export const AMBERWOOD_FROM_PRICES: { bedroom: number; label: string }[] = [
  { bedroom: 3, label: '$2.542M' },
  { bedroom: 4, label: '$3.143M' },
  { bedroom: 5, label: '$3.952M' },
];
const PROMOTED_BEDROOMS = [3, 5];
const MAX_BEDROOM = 10;

/**
 * The 3BR/5BR sizes a Project Research search covers — the same reading of
 * min/max as the results tables (min only = "at least", max only = "at most").
 * Empty when the search names no bedroom or is penthouse-only.
 */
export function amberwoodBannerBedrooms(min?: string | number | null, max?: string | number | null, phOnly?: boolean): number[] {
  if (phOnly) return [];
  const lo = parseInt(String(min ?? ''), 10);
  const hi = parseInt(String(max ?? ''), 10);
  if (!Number.isFinite(lo) && !Number.isFinite(hi)) return [];
  const from = Number.isFinite(lo) ? (Number.isFinite(hi) ? Math.min(lo, hi) : lo) : 1;
  const to = Number.isFinite(hi) ? (Number.isFinite(lo) ? Math.max(lo, hi) : hi) : MAX_BEDROOM;
  return PROMOTED_BEDROOMS.filter(b => b >= from && b <= to);
}

type Props = {
  bedrooms: number[];
  onOpen: () => void;
  onDismiss: () => void;
};

export default function AmberwoodResearchBanner({ bedrooms, onOpen, onDismiss }: Props) {
  const sizes = bedrooms.map(b => `${b}-bedder`).join(' or ');
  return (
    <section className="amberwood-banner" aria-label="Featured project: Amberwood at Holland">
      <button type="button" className="amberwood-banner-open" onClick={onOpen}>
        <span className="amberwood-banner-glow" aria-hidden="true" />
        <span className="amberwood-banner-sheen" aria-hidden="true" />
        <span className="amberwood-banner-dust" aria-hidden="true">{Array.from({ length: 10 }, (_, i) => <i key={i} style={{ '--i': i } as React.CSSProperties} />)}</span>
        <span className="amberwood-banner-poster" aria-hidden="true"><img src={AMBERWOOD_POSTER} alt="" /></span>
        <span className="amberwood-banner-copy">
          <span className="amberwood-banner-eyebrow"><span className="amberwood-banner-pulse" />Looking for a {sizes}?</span>
          <span className="amberwood-banner-question">Have you considered</span>
          <span className="amberwood-banner-title">Amberwood <small>at Holland</small></span>
          <span className="amberwood-banner-facts">District 10 · Holland enclave · 1km to MGS · walk to King Albert Park MRT</span>
        </span>
        <span className="amberwood-banner-prices">
          {AMBERWOOD_FROM_PRICES.map(price => (
            <span key={price.bedroom} className={`amberwood-banner-price ${bedrooms.includes(price.bedroom) ? 'amberwood-banner-price--match' : ''}`}>
              <b>{price.bedroom}BR</b><small>from</small>{price.label}
            </span>
          ))}
        </span>
        <span className="amberwood-banner-cta">Explore Amberwood <span aria-hidden="true">↗</span></span>
      </button>
      <button type="button" className="amberwood-banner-close" onClick={onDismiss} aria-label="Hide Amberwood suggestion">×</button>
    </section>
  );
}
